module.exports = __webpack_public_path__ + "static/media/wow7.74775868.mp3";